<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
  <div class="edit-user-profile">
      <!-- navbar -->
      <nav-bar />

      <div class="user-settings">
          <!-- tabs bar -->
          <div class="change-details">
              <tabs-bar></tabs-bar>
          </div>

          <!-- form -->
          <div class="user-form">
              <a href="#!" class="menu" @click="opensidebar()"><i class="fas fa-bars fa-2x"></i></a>
              <div class="user-form-box p-4">
                  <div class="card-body">
                      <h1 class="font-weight-bold text-center">
                      Invite Members
                      </h1>
                      <b-form
                      @submit.prevent="formSubmitted"
                      @keydown="form.onKeydown($event)"
                      class="mt-5 row"
                      >
                      <b-col sm="6">
                          <b-form-group>
                          <template v-slot:label>
                              First Name <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              v-model="form.first_name"
                              v-bind:class="{
                              'is-invalid': form.errors.has('first_name'),
                              }"
                          ></b-form-input>
                          <has-error :form="form" field="first_name"></has-error>
                          </b-form-group>
                      </b-col>

                      <b-col sm="6">
                          <b-form-group>
                          <template v-slot:label>
                              Last Name <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              v-model="form.last_name"
                              v-bind:class="{
                              'is-invalid': form.errors.has('last_name'),
                              }"
                          ></b-form-input>
                          <has-error :form="form" field="last_name"></has-error>
                          </b-form-group>
                      </b-col>

                      <b-col sm="12">
                          <b-form-group>
                          <template v-slot:label>
                              Email <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              v-model="form.email"
                              v-bind:class="{
                              'is-invalid': form.errors.has('email'),
                              }"
                          ></b-form-input>
                          <has-error :form="form" field="email"></has-error>
                          </b-form-group>
                      </b-col>

                      <b-col sm="12">
                          <!-- <b-alert
                          show
                          variant="success"
                          v-if="successMessage"
                          dismissible
                          >{{ successMessage }}</b-alert
                          > -->
                          <b-button
                          :disabled="form.busy"
                          type="submit"
                          variant="primary"
                          class="btn-grad float-right mt-4"
                          >Invite</b-button
                          >
                      </b-col>
                      </b-form>
                  </div>
              </div>
          </div>
      </div>
  </div>
</b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import { Form, HasError } from "vform";
import TabsBar from "../includes/TabsBar.vue";
import toggleMixin from "../../../../mixins/toggleMixin.js";
import Swal from "sweetalert2";

export default {
  props: [],
  components: {
    TabsBar,
    HasError,
    NavBar,
  },

  mixins: [toggleMixin],
  data() {
    return {
      form: new Form({
        first_name: "",
        last_name: "",
        email: "",
      }),
      // successMessage: "",
    };
  },
  methods: {
    formSubmitted() {
      this.$root.$data.bsLoader = true;
      this.form.post("api/contractor/invite-members").then(() => {
        // this.successMessage = "Invitation sent successfully to " + this.form.email;
         Swal.fire({
          title: "Invitation sent successfully to " + this.form.email + ".",
          icon: "success",
          timer: 5000,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
        });

        this.form.first_name = "";
        this.form.last_name = "";
        this.form.email = "";

        this.$root.$data.bsLoader = false;
      }).catch((err) => {
        this.$root.$data.bsLoader = false;
      });
    },

    opensidebar(){
        let sidebarDetails = document.querySelector('.change-details');
        this.toggleProfile(sidebarDetails)
    }
  },
};
</script>


        